// extracted by mini-css-extract-plugin
module.exports = {"CountryInformation":"CountryInformation_CountryInformation__kBtlA","CountryInformationTitle":"CountryInformation_CountryInformationTitle__r_OWV"};